import { render, staticRenderFns } from "./CardPlaceholder.vue?vue&type=template&id=6957d64c&scoped=true"
import script from "./CardPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CardPlaceholder.vue?vue&type=style&index=0&id=6957d64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957d64c",
  null
  
)

export default component.exports